export enum SyncJobStatus {
  InProgress,
  Paused,
  PartialCompletion,
  FullCompletion,
  Cancelled
}
